module.exports = __webpack_public_path__ + "static/media/background-santander.18883969.svg";